const ModalGroupsCategoriesSubs = ({
  refModal,
  groupsCategoriesSubs = [],
  processController,
  setProcessController = () => {},
}) => {
  // ------------- Functions -------------
  const handleSelectCategorySub = (id, name) => {
    setProcessController((prev) => ({
      ...prev,
      step: 2,
      group_category_sub: {
        id,
        name,
      },
    }))
    document.querySelector('.modal-close-button')?.click()
  }
  return (
    <div className="modal-groups-categories-subs">
      {groupsCategoriesSubs?.map((categoriesSub) => (
        <div className="groups-category-sub-item" key={categoriesSub?.id}>
          <div className="info">
            <span>{categoriesSub?.name}</span>
          </div>
          <div className="actions">
            <button
              className="btn btn-migrates-white-orange"
              onClick={() => {
                handleSelectCategorySub(categoriesSub?.id, categoriesSub?.name)
              }}
            >
              REALIZAR TRÁMITE
            </button>
          </div>
        </div>
      ))}
      <div className="modal-groups-categories-subs-footer">
        <button
          className="btn btn-migrates-white"
          onClick={() => {
            document.querySelector('.modal-close-button')?.click()
          }}
        >
          Cerrar
        </button>
      </div>
    </div>
  )
}

export default ModalGroupsCategoriesSubs
